<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
  <div class="top">
    <a routerLink="/home/vacations/drivers">
      <h3>Tetris /</h3>
      <div class="breadcrumb">
        <mat-icon svgIcon="arrow back"></mat-icon>
        <h2>{{ exercise?.name }}</h2>
      </div>
      <div class="subtitle">
        Período del ejercicio: {{ exercise?.start_date }} -
        {{ exercise?.end_date }}
      </div>
    </a>
    <div class="boton">
      <app-vacation-switch [exerciseActive]="exercise?.active" [exerciseId]="exercise?.id"></app-vacation-switch>
      <button class="b1" mat-button [routerLink]="[
          '/home/vacations/drivers/exercise',
          exercise?.id,
          exercise?.year,
          'edit'
        ]">
        Editar ejercicio
      </button>
      <button class="b1" mat-button (click)="syncOperatives()">Sincronizar operativas</button>
      <button class="b1" mat-button (click)="syncDrivers()">Sincronizar conductores</button>
    </div>
  </div>

  <div class="header-cards">
    <!-- TODO: Hacer componente de card -->
    <div class="card">
      <div class="title">CHÓFERES TOTALES</div>
      <div class="numbers">
        <!-- @if (exercise?.available_drivers == exercise?.total_drivers) {
        <mat-icon id="check">check_circle</mat-icon>
        }@else{
        <mat-icon>error</mat-icon>
        } -->
        <span>{{ exercise?.stats?.total_drivers }}</span>
      </div>
    </div>
    <div class="card">
      <div class="title">CAMIONES TOTALES</div>
      <div class="numbers">
        <!-- @if (exercise?.available_trucks == exercise?.total_trucks) {
        <mat-icon id="check">check_circle</mat-icon>
        }@else{
        <mat-icon>error</mat-icon>
        } -->
        <span>{{ exercise?.stats?.total_trucks }}</span>
      </div>
    </div>
    <div class="card">
      <div class="title">MODO</div>
      <div class="numbers">
        @if (exercise?.['configuration']?.continuous_phase) {
        <span>Fase continua</span>
        } @else if (exercise?.['configuration']?.initial_petition) {
        <span>Petición inicial</span>
        } @else {
        <span>-</span>
        }
      </div>
    </div>
  </div>
</div>

<div class="content">
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="OPERATIVAS">
      <div class="cards">
        @for(op of data; track op.id) {
        <app-operational-card [operative]="op"></app-operational-card>
        }
      </div>
    </mat-tab>

    <!-- <mat-tab label="NOTIFICACIONES"> </mat-tab> -->
  </mat-tab-group>
</div>